import AdminMerchantsPage from '../../../components/admin/merchants/AdminMerchantsPage'

export default function Merchants() {
  return <AdminMerchantsPage />
}
